// 切换皮肤
import React, { useState, useEffect, useReducer, useRef, useMemo, forwardRef } from "react";
import { injectIntl, useIntl } from "react-intl";
import { produce } from "immer";
import styles from "@/components/switchTheme.style.js";
import { makeStyles } from "tss-react/mui";
import { useTheme } from "@mui/material/styles";
import CONST from "@/config/const";
import { usePageMode } from "@/model/usePageMode";
import arrow_down from "@/assets/svg/arrow_down.svg";
import radio_check from "@/assets/svg/radio-check.svg";
import { Button, Popover } from "@mui/material";
import route_map from "../config/route_map";

const useStyles = makeStyles()(styles);
let timer2 = null;
let initState = {
  open: false,
  timer: null,
  isEnter: null,
};
const reducer = produce((draft, action = { paylod: {}, type: "@@INTT" }) => {
  const { type, payload } = action;
  switch (type) {
    default:
      Object.keys(payload).map((item) => {
        draft[item] = payload[item];
      });
  }
}, initState);

const DownloadPopoverRC = (props, ref) => {
  const intl = useIntl();
  const { classes, cx } = useStyles();
  const { lang, changeLang, appdownload } = usePageMode();
  const ref_dom = useRef();
  const timer = useRef();

  const [state, dispatch] = useReducer(reducer, initState);
  const mouseEnter = () => {
    clearTimeout(timer2);
    timer2 = null;
    dispatch({
      payload: {
        isEnter: "download",
      },
    });
  };
  const mouseLeave = () => {
    timer2 = setTimeout(() => {
      dispatch({
        payload: {
          isEnter: null,
        },
      });
    }, 50);
  };

  return (
    <>
      <div
        className={cx(classes.header_popover_btn, props.className)}
        ref={ref_dom}
        style={props.style || {}}
        onMouseEnter={() => mouseEnter("download")}
        onMouseLeave={mouseLeave}
      >
        {props.children}
        <div
          className={cx("header_popover", state.isEnter === "download" ? classes.showPopover : "")}
          style={{ right: 0, top: 23, ...(props.popstyle || {}) }}
        >
          <div className={cx(classes.qrcode)}>
            <div>{appdownload.app_page_url ? <img src={appdownload.app_page_url} /> : ""}</div>
            <p>{intl.formatMessage({ id: "header.appDownLoad" })}</p>
            <a href={appdownload.download_serve_url} target="_blank">
              {intl.formatMessage({ id: "header.moreload" })}
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default forwardRef(DownloadPopoverRC);
